import request from '@/utils/request'

export function getSwapExercises(params) {
    return request({
        url: `/api/exercise/get-swappable-exercises`,
        method: 'get',
        params
    })
}
